import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteParams } from '../../hooks/useRouteParams';
import { receiveData } from '../../../../FinancialPlan/FinancialPlanActions';
import { useFinancialPlanQuery } from '../../../api/useFinancialPlanQuery';
import { setGoalId } from '../../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownActions';

/**
 * Populate legacy financial plan reducers, with
 * Goal Id and financial plan data.
 */
export const useLegacyWhatIfs = (): void => {
  const dispatch = useDispatch();

  const queryResult = useFinancialPlanQuery();

  const { clientId, goalId } = useRouteParams();

  useEffect(() => {
    if (queryResult.data) {
      dispatch(setGoalId(goalId, clientId));
      dispatch(receiveData(queryResult.data, clientId, false));
    }
  }, [queryResult.data, clientId, dispatch, goalId]);
};
